export { default as Selector } from './Selector'
export type { SelectorProps, SelectorOption } from './types'
